import axios from 'axios';
import { defineStore } from 'pinia';

export const useFancyTablesStore = defineStore('fancy-tables', () => {
  const getSavedTableStates = async (tableName: string): Promise<any[]> => {
    try {
      const { data } = await axios.get(`/common/fancy-tables/${tableName}/`);

      return data;
    } catch (error: any) {
      console.error(error);

      throw error;
    }
  };

  const saveTableState = async (tableName: string, state: any) => {
    try {
      const { data } = await axios.post(`/common/fancy-tables/${tableName}/`, state);

      return data;
    } catch (error: any) {
      console.error(error);

      throw error;
    }
  };

  const updateTableState = async (id: number, state: any) => {
    try {
      const { data } = await axios.patch(`/common/fancy-tables/${id}/`, state);

      return data;
    } catch (error: any) {
      console.error(error);

      throw error;
    }
  };

  const deleteTableState = async (id: number) => {
    try {
      const { data } = await axios.delete(`/common/fancy-tables/${id}/`);

      return data;
    } catch (error: any) {
      console.error(error);

      throw error;
    }
  };

  const markTableStateAsDefault = async (id: number) => {
    try {
      const { data } = await axios.post(`/common/fancy-tables/${id}/default/`);

      return data;
    } catch (error: any) {
      console.error(error);

      throw error;
    }
  };

  return {
    getSavedTableStates,
    saveTableState,
    updateTableState,
    deleteTableState,
    markTableStateAsDefault,
  };
});
